import React from 'react'
import ImageComponent from './image';

const SectionComponent = props =>
    <div className={props.section.frontmatter.class} id={props.section.frontmatter.hash}>
        <div className="section__grid">
            <div className="section__img">
                <ImageComponent image={props.section.frontmatter.image} />
            </div>
            <div className="section__text" dangerouslySetInnerHTML={{ __html: props.section.html }}></div>
        </div>
    </div>

export default SectionComponent



// WEBPACK FOOTER //
// ./src/components/section.js